exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".robot-container{position:absolute;width:20px;height:20px;z-index:50}.robot-container .robot{background-color:red;width:12px;height:12px;border-radius:6px;border:1px solid #000;margin:4px 0 0 10px}.robot-container .arrow{display:none;background-color:blue;opacity:.3;border:2px solid gray;position:absolute;width:12px;height:12px}@media (min-width:700px){.play-mode .robot-container{width:40px;height:40px}.play-mode .robot-container .robot{width:24px;height:24px;border-radius:12px;border:1px solid #000;margin:10px 0 0 18px}.play-mode .robot-container .arrow{width:24px;height:24px}.play-mode .robot-container:hover .arrow{display:block}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./styles/modules/robot.scss
// module id = 304
// module chunks = 0